import type { EffectiveServiceOffering } from "@/lib/service/types";
import { isScheduleReadyOpportunityStatus } from "@/lib/opportunity/schedulingNotes";

export function normalizeOpportunityProductTypeKey(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, "_");
}

function isQuotableActiveOffering(offering: EffectiveServiceOffering): boolean {
  return offering.is_active && offering.quotable_from_sales;
}

/** Match opportunity product_type to a quotable service offering (local first, then inherited). */
export function resolveQuotableServiceOfferingForProductType(
  offerings: EffectiveServiceOffering[],
  productType: string
): EffectiveServiceOffering | null {
  const pool = offerings.filter(isQuotableActiveOffering);
  const key = normalizeOpportunityProductTypeKey(productType);
  if (!key || key === "other") return null;

  const searchPool = (list: EffectiveServiceOffering[]): EffectiveServiceOffering | null => {
    const bySlug = list.find((o) => normalizeOpportunityProductTypeKey(o.slug) === key);
    if (bySlug) return bySlug;
    return list.find((o) => normalizeOpportunityProductTypeKey(o.label) === key) ?? null;
  };

  const hasInherited = pool.some((o) => o.is_inherited);
  if (hasInherited) {
    const local = pool.filter((o) => !o.is_inherited);
    const inherited = pool.filter((o) => o.is_inherited);
    return searchPool(local) ?? searchPool(inherited);
  }
  return searchPool(pool);
}

export function shouldShowServiceClosedCallout(
  status: string,
  matchedOffering: EffectiveServiceOffering | null
): boolean {
  return matchedOffering != null && isScheduleReadyOpportunityStatus(status);
}
